import { Button } from '@cian/ui-kit';
import * as React from 'react';

import { useSearchSetParams } from './useSearchSetParams';

export const SubscribeButtonContainer: React.FC = () => {
  const handleClick = useSearchSetParams();

  return (
    <Button data-name="SubscribeButtonContainer" size="XS" theme="fill_secondary" onClick={handleClick}>
      Подписаться на дом
    </Button>
  );
};

SubscribeButtonContainer.displayName = 'SubscribeButtonContainer';
